export const levelOption = (t) => [
    {
        label: t("Unit Level"),
        value: "Unit Level"
    },
    {
        label: t("Account Level"),
        value: "Account Level"
    }
]